import { planTypes } from "@/common/constants";
import { getPlanLogo } from '@/common/plan-logo-map';

export default {
  key: planTypes[planTypes.CMR],
  data () {
    return {
      title: this.$t('billing.cmr.title'),
      subtitle: '',
      description: this.$t('billing.cmr.desc'),
      logo: getPlanLogo(planTypes.CMR),
      planType: planTypes.CMR,
    }
  }
};
